// extracted by mini-css-extract-plugin
export default {"Mcontainer":"Mcontainer__CUeJ9","Mobile_frame":"Mobile_frame__Xpxxy","Mobile_frame_Two":"Mobile_frame_Two__UPCKv","desktop_frame":"desktop_frame__+zaj9"};